import { SessionCard } from "@/cards/SessionCard";
import { useSocket } from "@/hooks/useSocket";
import { SessionDocument, TotalSubsUpdatedEvent, UpdateSessionEvent } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";

export const Session: FC = () => {
    const socket = useSocket();
    const [session, setSession] = useState<SessionDocument | null>(null);
    const [currentSubs, setCurrentSubs] = useState<number>(0);

    useEffect(() => {
        socket.emit("get-session", s => {
            setSession(s);
        });

        socket.emit("get-total-subs", (subs) => {
            // @todo multi channels?
            const count = subs[0][1] ?? 0;
            setCurrentSubs(count);
        });

        const onSessionUpdate = (e: UpdateSessionEvent) => {
            setSession(e.session);
        }
        socket.on("update-session", onSessionUpdate);

        const onTotalSubsUpdate = (e: TotalSubsUpdatedEvent) => {
            // @todo multi channels?
            setCurrentSubs(e.subCount);
        }
        socket.on("sub-count-updated", onTotalSubsUpdate);

        return () => {
            socket.off("update-session", onSessionUpdate);
            socket.off("sub-count-updated", onTotalSubsUpdate);
        }
    }, [socket]);

    const reset = useCallback(() => {
        socket.emit("reset-session");
    }, [socket]);

    if (!session) {
        return (
            <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 grid gap-2">
                    <form className="w-1/6 mx-auto flex flex-col flex-3/4 dark:bg-gray-800 p-5 rounded-3xl">
                        No open session found.
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-12 gap-6">
            <SessionCard session={session} currentSubs={currentSubs} reset={reset} />
        </div>
    )
}